import { useState, type FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import { siteStats } from "@/mocks/site";

const hotTags = ["实锤证据", "录音比对", "时间线", "后台截图", "口径反复"];

export default function Hero() {
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const handleSearch = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const value = keyword.trim();
    navigate(value ? `/events?q=${encodeURIComponent(value)}` : "/events");
  };

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[720px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=abstract%20dark%20investigative%20scene%20with%20warm%20amber%20light%20beams%20cutting%20through%20smoke%2C%20scattered%20blurred%20documents%20and%20magnifying%20glass%20silhouette%2C%20crimson%20accents%2C%20cinematic%20moody%20atmosphere%2C%20high%20contrast%2C%20fine%20film%20grain&width=1600&height=1000&seq=chigua-hero-bg&orientation=landscape"
        alt="暖色光束穿过暗色烟雾的抽象背景，象征证据整理与核对"
        className="absolute inset-0 w-full h-full object-cover object-top animate-slow-zoom"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/70 via-background-50/60 to-background-50" />

      <div className="relative w-full max-w-[1280px] mx-auto px-4 md:px-6 pt-28 pb-16 md:pt-36 md:pb-20">
        <div className="max-w-3xl animate-rise">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-primary-300/50 bg-primary-100/50 text-xs md:text-sm text-primary-300">
            <i className="ri-pulse-line" />
            证据合集持续整理更新中 · 今日新增 18 条
          </span>

          <h1 className="mt-6 font-heading text-3xl sm:text-4xl md:text-6xl font-black text-foreground-950 leading-[1.15]">
            131吃瓜 · 实锤与证据合集
          </h1>

          <p className="mt-5 text-sm md:text-lg leading-7 md:leading-8 text-foreground-600 max-w-2xl">
            不想听单方讲故事，就直接翻这个证据汇总栏。截图证据、录音证据、文字记录与时间线按事件类型整理在一起，方便你对照前后说法，自己判断。
          </p>

          <form onSubmit={handleSearch} className="mt-8 flex flex-col sm:flex-row gap-3 max-w-xl">
            <div className="relative flex-1">
              <span className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-foreground-400">
                <i className="ri-search-2-line" />
              </span>
              <label htmlFor="hero-search" className="sr-only">
                搜索事件或证据
              </label>
              <input
                id="hero-search"
                name="q"
                type="text"
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="搜索事件、关键词或证据类型"
                className="w-full h-12 pl-11 pr-4 rounded-md bg-background-100 border border-background-200 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-400/30"
              />
            </div>
            <button
              type="submit"
              className="h-12 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              查找证据
            </button>
          </form>

          <div className="mt-6 flex flex-wrap items-center gap-2 md:gap-3">
            {hotTags.map((tag) => (
              <Link
                key={tag}
                to={`/events?q=${encodeURIComponent(tag)}`}
                className="px-3 py-1.5 rounded-full border border-background-200 text-xs md:text-sm text-foreground-600 hover:text-primary-500 hover:border-primary-300 transition-colors cursor-pointer whitespace-nowrap"
              >
                {tag}
              </Link>
            ))}
          </div>
        </div>

        <dl className="mt-12 md:mt-16 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 max-w-4xl">
          {siteStats.map((stat) => (
            <div key={stat.label} className="rounded-lg border border-background-200/70 bg-background-100/70 backdrop-blur-sm px-5 py-4">
              <dt className="text-xs md:text-sm text-foreground-500">{stat.label}</dt>
              <dd className="mt-1 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                {stat.value}
                <span className="ml-1 text-sm font-normal text-primary-500">{stat.suffix}</span>
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}